import { render, staticRenderFns } from "./WaitingAnimation.vue?vue&type=template&id=4da98743&"
var script = {}
import style0 from "./WaitingAnimation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports